import React from "react";
import { createUseStyles } from "react-jss";
import { THEME } from "../../theming/theming";
export function TableEmpty(props) {
    const classes = useTableEmptyClasses();
    return (React.createElement("div", { className: classes.noResult, role: "row", "data-rowindex": "0", "aria-rowindex": 1 },
        React.createElement("p", { role: "cell", "aria-colindex": 1, "data-colindex": "0", className: classes.text }, props.noDataText ?? "No Results")));
}
const useTableEmptyClasses = () => {
    const useStyles = createUseStyles({
        noResult: {
            padding: 8,
            textAlign: "center",
            backgroundColor: THEME.palette.gray.white.color,
            "> p": {
                marginBottom: 0,
            },
        },
        text: {
            marginBottom: 0,
        },
    });
    return useStyles();
};
